import { Account } from '../../Model/Account';
import { AccountRepository } from '../Repositories/AccountRepository';
import { stripSuffix } from '../../../../Utils/usernameSuffix';

export class GetAccountsUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(): Promise<Account[]> {
    return this.repo
      .getAccounts()
      .then(res => res.map(acc => ({ ...acc, username: stripSuffix(acc.username) })))
      .catch(err => Promise.reject(err));
  }
}
